module.exports = __webpack_public_path__ + "img/telephone_booth.afe44081.jpg";